import { memo, useEffect } from 'react';
import { Marker, Popup, useMap } from 'react-leaflet';

interface IAdMarkerProps {
  datas: AdMarkerDatas;
}
function AdMarker({ datas }: IAdMarkerProps) {
  const { coordinates, popup, isCenter, icon, onClick } = datas;
  const map = useMap();

  useEffect(() => {
    if (isCenter && coordinates) {
      map.panTo([coordinates?.lat, coordinates.lng]);
    }
  }, [isCenter, coordinates]);

  if (!coordinates || !icon) return null;

  return (
    <Marker
      position={coordinates}
      icon={icon}
      eventHandlers={onClick ? { click: onClick } : {}}
    >
      {popup ? <Popup offset={[0, -10]}>{popup}</Popup> : null}
    </Marker>
  );
}

export default memo(AdMarker);
